export default "__VITE_ASSET__BwsrWqqj__"